// extracted by mini-css-extract-plugin
export default {"tariffs_container":"tariffs_tariffs_container__ceaou"};